import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as yup from "yup";
import { createSeries } from "../../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { toast } from "react-toastify";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { LoadingButton } from "@mui/lab";
import { createSeason } from "../../graphql/mutations";
import { listSeasons, listSeries } from "../../graphql/queries";
import { useDispatch } from "react-redux";
import { setSeasonCreated } from "../../redux/slices/contentSlice/contentForm/contentForm";
import AddIcon from "@mui/icons-material/Add";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const validationSchema = yup.object({
  title: yup
    .string("Enter the name of the series")
    .required("Name is required!"),
  seriesID: yup
    .string("Enter the name of the series")
    .required("Series is required!"),
  seasonNumber: yup.number().required("Season Number is required!"),
});
const client = generateClient();
const CreateSeason = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [isLoading, setLoading] = useState(false);
  const [series, setSeries] = useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const formik = useFormik({
    initialValues: {
      title: "",
      plot: "",
      description: "",
      releaseDate: "",
      seasonNumber: "",
      seriesID: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Close the modal after submission
      try {
        setLoading(true);
        const response = await client.graphql({
          query: createSeason,
          variables: {
            input: {
              title: values.title,
              seriesID: values.seriesID,
              seasonNumber: values.seasonNumber,
            },
          },
        });
        if (response.data.createSeason) {
          dispatch(setSeasonCreated(true));
          toast.success("Season has been created!");
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });
  console.log(formik, "formik");

  useEffect(() => {
    const fetchSeriesIDRecords = async () => {
      try {
        setLoading(true);
        const response = await client.graphql({
          query: listSeries,
        });
        setSeries(response.data.listSeries.items);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSeriesIDRecords();
  }, []);

  return (
    <>
      <Button variant="contained" onClick={handleOpen}>
        <AddIcon />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="create-series-modal"
        aria-describedby="create-series-description"
      >
        <form onSubmit={formik.handleSubmit}>
          <Box sx={style}>
            <Typography id="create-series-modal" variant="h6" component="h2">
              Create Season
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Title of the season"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.title && Boolean(formik.errors.title)}
                  helperText={formik.touched.title && formik.errors.title}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" margin="normal">
                  <InputLabel id="select-series-label">
                    Select Series
                  </InputLabel>
                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <>
                      <Select
                        labelId="select-series-label"
                        onChange={formik.handleChange}
                        label="Select Series"
                        name="seriesID"
                        value={formik.values.seriesID}
                      >
                        {series.map((series) => (
                          <MenuItem key={series.id} value={series.id}>
                            {series.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {formik.errors.seriesID && (
                        <Typography sx={{ color: "red" }}>
                          {formik.errors.seriesID}
                        </Typography>
                      )}
                    </>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl>
                  <TextField
                    onChange={formik.handleChange}
                    name="seasonNumber"
                    type="number"
                    label="Season Number"
                    error={
                      formik.touched.title &&
                      Boolean(formik.errors.seasonNumber)
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <LoadingButton
              variant="contained"
              color="primary"
              loading={isLoading}
              type="submit"
              sx={{ mt: 2 }}
            >
              Create Season
            </LoadingButton>
          </Box>
        </form>
      </Modal>
    </>
  );
};

export default CreateSeason;
